module.exports = __webpack_public_path__ + "static/media/coxs3.3f5188da.png";